import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { take } from 'rxjs/operators';
import { ProgramService, StandardService } from '../../../compliance/services';
import { TransactionType } from '../../../compliance/enums';
import { Program, Standard } from '../../../compliance/models';

@Component({
  selector: 'kt-med-review-add-standard',
  templateUrl: './med-review-add-standard.component.html',
})
export class MedReviewAddStandardComponent implements OnInit {
  form: FormGroup;
  getProgramAutocomplete = this.programService.searchProgram.bind(this.programService);
  getStandardAutocomplete = this.standardService.searchStandard.bind(this.standardService);

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<MedReviewAddStandardComponent>,
    private formBuilder: FormBuilder,
    private programService: ProgramService,
    private standardService: StandardService,
  ) {}

  ngOnInit(): void {
    this.form = this.formBuilder.group({
      program: [null, Validators.required],
      standards: [[], Validators.required],
    });

    this.standardService
      .getStandardListByTransaction(0, TransactionType.MED_REVIEW)
      .pipe(take(1))
      .subscribe((res) => {
        this.form.get('standards').patchValue(res);
      });
  }

  formatProgramOption(program: Program): string {
    return program ? program.name : '';
  }

  onProgramChange(program: Program): void {
    this.form.get('program').patchValue(program);
    this.getStandardAutocomplete = this.standardService.searchStandard.bind(
      this.standardService,
      program.id,
      false,
    );
  }

  formatStandardOption(standard: Standard): string {
    return standard
      ? `${standard.standard_reference}<small class="text-muted ml-4">${
          standard.program ? standard.program.name : ''
        }</small>`
      : '';
  }

  formatNewStandard(standard: Standard): Standard {
    return standard;
  }

  onStandardChange(standards: Standard[]): void {
    this.form.get('standards').patchValue(standards);
  }

  isInvalid(name: string): boolean {
    const field = this.form.get(name);

    return field.touched && field.invalid;
  }

  getErrorMessage(name: string): string {
    return `${name} field is required`;
  }

  onClose(event): void {
    event.stopPropagation();

    this.dialogRef.close();
  }

  onSubmit(event): void {
    event.stopPropagation();

    const standards = this.form.get('standards').value;
    const standardIds =
      standards && standards.length ? standards.map((standard) => standard.id) : [];

    this.standardService
      .setStandardListByTransaction(0, TransactionType.MED_REVIEW, standardIds)
      .pipe(take(1))
      .subscribe(() => this.dialogRef.close(true));
  }
}
